import React from 'react'
import { Link } from 'wouter'
import './Logo.scss'

const Logo = ({url, footer}) => {
  return (
    <Link href="/">
      <div className={`foresight--logo ${footer && "footer"}`}>
        <img src={url} alt="Logo foresightgps" />
      </div>
    </Link>
  )
}

export default Logo
